import React from 'react';
import { Popover, Title, Text, Button, ActionIcon } from "rizzui";
import { TrashIcon, PencilIcon, EyeIcon } from "@heroicons/react/24/outline";

function DeleteButton({ onDelete, itemName = "user" }) {
  return (
    <span onClick={(e) => e.stopPropagation()}>
      <Popover>
        <Popover.Trigger>
          <ActionIcon variant="outline" rounded="md" size="sm" className="border-gray-200">
            <TrashIcon className="w-4 h-4" />
          </ActionIcon>
        </Popover.Trigger>
        <Popover.Content>
          {({ setOpen }) => (
            <div className="w-56">
              <Title as="h6">Delete {itemName}</Title>
              <Text>Are you sure you want to delete this {itemName}?</Text>
              <div className="flex justify-end gap-3 mb-1">
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => setOpen(false)}
                >
                  No
                </Button>
                <Button
                  size="sm"
                  onClick={() => {
                    if (onDelete) onDelete();
                    setOpen(false);
                  }}
                >
                  Yes
                </Button>
              </div>
            </div>
          )}
        </Popover.Content>
      </Popover>
    </span>
  );
}


// For a complete set of actions matching the image
export function ActionButtons({ onView, onEdit, onDelete, itemName = "item" }) {
  return (
    <div className="flex items-center gap-2">
      <ActionIcon 
        variant="outline" 
        rounded="md" 
        size="sm" 
        className="border-gray-200"
        onClick={(e) => {
          e.stopPropagation();
          if (onEdit) onEdit();
        }}
      >
        <PencilIcon className="w-4 h-4" />
      </ActionIcon>
      
      <ActionIcon 
        variant="outline" 
        rounded="md" 
        size="sm" 
        className="border-gray-200"
        onClick={(e) => {
          e.stopPropagation();
          if (onView) onView();
        }}
      >
        <EyeIcon className="w-4 h-4" />
      </ActionIcon>
      
      <DeleteButton onDelete={onDelete} itemName={itemName} />
    </div>
  );
}

export default DeleteButton;


